import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Loader from "../../../components/Loader";
import BootstrapTable from "react-bootstrap-table-next"; // https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import paginationFactory from "react-bootstrap-table2-paginator";
import { verifyIsInternalUser } from "../../../state/reducers/userReducer";

// UI Components
import { Container, Card, CardBody } from "reactstrap";
import { campaignTableSchema, expandCallWindowConfigRow } from "./campaignTableSchema";
import Header from "./Header";
// State
import { getCampaigns, updateCampaign } from "../../../state/actions/campaignActions";

const RECORDS_PER_PAGE = "campaignsRecordsPerPage";

const CampaignList = ({
  loading,
  campaignList,
  getCampaigns,
  updateCampaign,
  nonExpandableKeys,
  expandableKeys,
  user,
}) => {
  const [recordsPerPage] = useState(localStorage.getItem(RECORDS_PER_PAGE) || 50);
  const [isInternalUser, setInternalUser] = useState(false);
  const [hasUpdatePermission, setUpdatePermission] = useState(false);

  useEffect(() => {
    getCampaigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setInternalUser(verifyIsInternalUser(user));
    setUpdatePermission(user && user.group_id_bint ? user.group_id_bint > 1 : false);
  }, [user]);

  const onSave = (modifiedTemplate) => {
    updateCampaign(modifiedTemplate);
  };

  const LoaderSection = () => {
    if (loading) return <Loader />;
    return null;
  };

  return (
    <Container
      fluid
      className="p-0"
      id="CampaignBootstrapContainer"
      key="CampaignBootstrapContainer"
    >
      <Header />
      <LoaderSection />
      {!loading && (
        <>
          <Card>
            <CardBody>
              <BootstrapTable
                id="CampaignBootstrapTable"
                key="CampaignBootstrapTable"
                bootstrap4
                hover
                classes="table-responsive-md"
                keyField="id"
                data={campaignList || []}
                columns={campaignTableSchema()}
                bordered={false}
                expandRow={expandCallWindowConfigRow(
                  onSave,
                  loading,
                  nonExpandableKeys,
                  isInternalUser,
                  expandableKeys,
                  hasUpdatePermission
                )}
                pagination={paginationFactory({
                  sizePerPage: Number(recordsPerPage),
                  sizePerPageList: [5, 10, 25, 50, 75, 100],
                  onSizePerPageChange: (sizePerPage) => {
                    localStorage.setItem(RECORDS_PER_PAGE, sizePerPage);
                  },
                })}
              />
            </CardBody>
          </Card>
        </>
      )}
    </Container>
  );
};

CampaignList.propTypes = {
  loading: PropTypes.bool.isRequired,
  campaignList: PropTypes.array.isRequired,
  getCampaigns: PropTypes.func.isRequired,
  updateCampaign: PropTypes.func.isRequired,
  nonExpandableKeys: PropTypes.array.isRequired,
  expandableKeys: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.campaign.loading.campaign || state.campaign.loading.saving,
  campaignList: state.campaign.list,
  nonExpandableKeys: state.campaign.nonExpandableKeys,
  user: state.user.user,
  expandableKeys: state.campaign.expandableKeys,
});

export default connect(mapStateToProps, {
  getCampaigns,
  updateCampaign,
})(CampaignList);
